import { apiFetch } from "./apiClient";

export async function getCleaningPerformanceFilterOptions(filters = {}) {
  const params = new URLSearchParams();

  if (filters.startDate) {
    params.append("startDate", String(filters.startDate));
  }

  if (filters.endDate) {
    params.append("endDate", String(filters.endDate));
  }

  if (filters.buildingName) {
    params.append("buildingName", String(filters.buildingName));
  }

  if (filters.departmentFloor) {
    params.append("departmentFloor", String(filters.departmentFloor));
  }

  if (filters.roomName) {
    params.append("roomName", String(filters.roomName));
  }

  if (filters.departmentName) {
    params.append("departmentName", String(filters.departmentName));
  }

  const query = params.toString();
  const url = query
    ? `/api/services/performance/filter-options?${query}`
    : "/api/services/performance/filter-options";

  const response = await apiFetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch cleaning performance filter options");
  }

  const payload = await response.json();
  return payload?.options || {};
}

export async function getCleaningPerformanceRows(filters = {}) {
  const params = new URLSearchParams();

  if (filters.devicePkId != null) {
    params.append("devicePkId", String(filters.devicePkId));
  }

  if (filters.customerId != null) {
    params.append("customerId", String(filters.customerId));
  }

  if (filters.locationPkId != null) {
    params.append("locationPkId", String(filters.locationPkId));
  }

  if (filters.buildingPkId != null) {
    params.append("buildingPkId", String(filters.buildingPkId));
  }

  if (filters.departmentPkId != null) {
    params.append("departmentPkId", String(filters.departmentPkId));
  }

  if (filters.roomPkId != null) {
    params.append("roomPkId", String(filters.roomPkId));
  }

  if (filters.roomTypeId != null) {
    params.append("roomTypeId", String(filters.roomTypeId));
  }

  if (filters.roomType) {
    params.append("roomType", String(filters.roomType));
  }

  if (filters.departmentFloor) {
    params.append("departmentFloor", String(filters.departmentFloor));
  }

  if (filters.roomName) {
    params.append("roomName", String(filters.roomName));
  }

  if (filters.routePkId != null) {
    params.append("routePkId", String(filters.routePkId));
  }

  if (filters.routeName) {
    params.append("routeName", String(filters.routeName));
  }

  if (filters.robotName) {
    params.append("robotName", String(filters.robotName));
  }

  if (filters.section) {
    params.append("section", String(filters.section));
  }

  if (filters.buildingName) {
    params.append("buildingName", String(filters.buildingName));
  }

  if (filters.departmentName) {
    params.append("departmentName", String(filters.departmentName));
  }

  if (typeof filters.scheduled === "boolean") {
    params.append("scheduled", String(filters.scheduled));
  }

  if (typeof filters.failed === "boolean") {
    params.append("failed", String(filters.failed));
  }

  if (filters.startDate) {
    params.append("startDate", String(filters.startDate));
  }

  if (filters.endDate) {
    params.append("endDate", String(filters.endDate));
  }

  if (typeof filters.jobComplete === "boolean") {
    params.append("jobComplete", String(filters.jobComplete));
  }

  if (filters.limit != null) {
    params.append("limit", String(filters.limit));
  }

  if (filters.offset != null) {
    params.append("offset", String(filters.offset));
  }

  if (typeof filters.includeTotal === "boolean") {
    params.append("includeTotal", String(filters.includeTotal));
  }

  const query = params.toString();
  const url = query
    ? `/api/services/performance/cleaning-rows?${query}`
    : "/api/services/performance/cleaning-rows";

  const response = await apiFetch(url);

  if (response.status === 404) {
    return [];
  }

  if (!response.ok) {
    throw new Error("Failed to fetch cleaning performance rows");
  }

  const payload = await response.json();
  console.log("Payload received from API:", payload);

  if (Array.isArray(payload)) {
    return payload;
  }

  if (payload && Array.isArray(payload.rows)) {
    return payload;
  }

  return [];
}
